import { handleCartProducts } from './cartHelper.js';


export default function() {
    const PREFIX = '_RAINC_';
    const cartButtonLink = $('.shopping-cart-item');
    const SAVED_FORM_KEY = 'saved_form_url';
    const ACTIVE_TAB_KEY = '_RAINC_active_cart_tab';


    const vuexPrefixes = {
        "/place-an-order/": "vuex-RegisteredAgentApp.js",
        "/form-an-entity/": "vuex-FormABusinessApp.js",
        "/domain-signup/": "vuex-DomainSignupApp.js"
    };

    const formDisplayNames = {
        "/place-an-order/": "Registered Agent Signup",
        "/form-an-entity/": "Business Formation Signup",
        "/domain-signup/": "Domain Signup"
    };

    // Save all visited form's URL to local storage.
    const saveFormURL = () => {
        const onShoppingCartForm = $('.shopping-cart-signup-form').length;

        if (onShoppingCartForm) {
            const currentUrl = window.location.href;
            const slug = new URL(currentUrl).pathname;

            setLocalStorageItem(SAVED_FORM_KEY, currentUrl);

            let visitedForms = JSON.parse(localStorage.getItem(PREFIX + 'visited_forms')) || [];

            if (!visitedForms.includes(slug)) {
                visitedForms.push(slug);
                localStorage.setItem(PREFIX + 'visited_forms', JSON.stringify(visitedForms));
            }
        }
    };

    // Render the buttons in the cart header
    const renderCartTabs = () => {
        const tabContainer = document.getElementById('cart-tabs');
        tabContainer.innerHTML = '';

        const visitedForms = JSON.parse(localStorage.getItem(PREFIX + 'visited_forms')) || [];

        visitedForms.forEach(slug => {
            const button = document.createElement('button');
            button.textContent = formDisplayNames[slug] || slug;
            button.classList.add('cart-tab-btn');
            button.setAttribute('data-slug', slug);

            button.addEventListener('click', () => {
                loadCartBySlug(slug);
            });

            tabContainer.appendChild(button);
        });
    };

    // Display the form's cart products based on the button
    function loadCartBySlug(slug) {
        const vuexPrefix = vuexPrefixes[slug];
        if (!vuexPrefix) {
            console.warn("No Vuex prefix found for slug:", slug);
            return;
        }

        const vuexKey = Object.keys(localStorage).find(key =>
            key.startsWith(vuexPrefix)
        );

        if (!vuexKey) {
            console.warn("No Vuex key found for prefix:", vuexPrefix);
            return;
        }

        const vuexData = JSON.parse(localStorage.getItem(vuexKey));
        const products = vuexData?.cart?.cartProducts || [];

        // Update title link
        const titleEl = document.getElementById('cart-form-name');
        if (titleEl) {
            titleEl.textContent = formDisplayNames[slug] || '';
            titleEl.href = slug;
        }

        // Render the products in this cart
        handleCartProducts(products, '_RAINC_', 'saved_form_url');

        // Update checkout button behavior
        const checkoutBtn = document.querySelector('.checkout-btn');
        if (checkoutBtn) {
            checkoutBtn.onclick = () => {
                window.location.href = slug;
            };
        }
    }

    // Display active state to indicate which button was clicked
    function setupCartTabEvents() {
        const tabButtons = document.querySelectorAll('.cart-tab-btn');

        tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const slug = button.dataset.slug;

                tabButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');

                localStorage.setItem(ACTIVE_TAB_KEY, slug);
                loadCartBySlug(slug);
            });
            button.setAttribute('role', 'tab');
            button.setAttribute('aria-selected', 'false');
        });


    }

    // Set active tab + load correct cart on page load
    function initializeCartTabs() {
        const savedSlug = localStorage.getItem(ACTIVE_TAB_KEY);
        if (savedSlug) {
            const matchingButton = document.querySelector(`.cart-tab-btn[data-slug="${savedSlug}"]`);
            if (matchingButton) {
                matchingButton.classList.add('active');
                loadCartBySlug(savedSlug);
            }
        }
    }

    // Get a value from local storage by it's key.
    const getLocalStorageItem = (key, prefix = PREFIX) => {

        if (typeof Storage !== 'undefined') {
            return localStorage.getItem(prefix + key);
        }

        console.warn('No Web Storage support');
    };

    // Set a value to local storage.
    const setLocalStorageItem = (key, val, prefix = PREFIX) => {
        if (typeof Storage === 'undefined') {
            console.warn('No Web Storage support');
        } else {
            localStorage.setItem(prefix + key, val);
        }
    };

    // Dynamically show cart icon
    const maybeShowShoppingCart = () => {
        const currentUrl = window.location.href;
        const formUrl = getLocalStorageItem('saved_form_url');
        const onShoppingCartForm = $('.shopping-cart-signup-form').length;

        if (formUrl !== null) {
            cartButtonLink.attr('href', formUrl);
            setLocalStorageItem('previous_saved_form_url', formUrl);

            if (currentUrl !== formUrl && !onShoppingCartForm) {
                const iconContainer = $('.shopping-cart-icon')
                iconContainer.addClass('show-cart');
            }
        }
    };

    // Function to get Vuex cart data based on the form URL
    function getVuexCartDataBySlug(slug) {
        const vuexPrefix = vuexPrefixes[slug];
        if (!vuexPrefix) return null;

        const vuexKey = Object.keys(localStorage).find(key =>
            key.startsWith(vuexPrefix)
        );

        if (!vuexKey) return null;

        try {
            return JSON.parse(localStorage.getItem(vuexKey));
        } catch (e) {
            console.warn("Failed to parse vuex cart data:", e);
            return null;
        }
    }

    // Cart icon click behavior
    cartButtonLink.on('click', (event) => {
        event.preventDefault();

        const drawer = document.getElementById('cart-drawer');
        const overlay = document.getElementById('cart-overlay');

        if (drawer.classList.contains('show')) {
            drawer.classList.remove('show');
            overlay?.classList.remove('show');
            setTimeout(() => {
                drawer.classList.add('hidden');
                overlay?.classList.add('hidden');
            }, 300);
            return;
        }


        // Get visited forms
        const visitedForms = JSON.parse(localStorage.getItem(PREFIX + 'visited_forms')) || [];

        // Use saved active tab, or fall back to first visited form
        let savedSlug = localStorage.getItem('_RAINC_active_cart_tab');
        if (!savedSlug && visitedForms.length > 0) {
            savedSlug = visitedForms[0];
            localStorage.setItem('_RAINC_active_cart_tab', savedSlug);
        }

        // Load the cart for the active or fallback slug
        const cartData = getVuexCartDataBySlug(savedSlug);
        setCartFormNameFromSlug(savedSlug);

        // If cart data found, show it
        if (cartData) {
            const formCartProducts = cartData.cart.cartProducts;
            handleCartProducts(formCartProducts, PREFIX, SAVED_FORM_KEY);
            setActiveTabUI(savedSlug);
        }

        // Show the cart drawer regardless of cartData
        drawer.classList.remove('hidden');
        overlay?.classList.remove('hidden');
        setTimeout(() => {
            drawer.classList.add('show');
            overlay?.classList.add('show');
        }, 10);
    });

    // Handle case when one form is visited to update state
    function setActiveTabUI(slug) {
        document.querySelectorAll('.cart-tab-btn').forEach(btn => {
            if (btn.dataset.slug === slug) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }

    // Form title
    const setCartFormName = () => {
        const VISITED_FORMS_KEY = '_RAINC_visited_forms';

        const activeSlug = localStorage.getItem(ACTIVE_TAB_KEY);
        const visitedForms = JSON.parse(localStorage.getItem(VISITED_FORMS_KEY) || '{}');
        const formUrl = visitedForms[activeSlug];

        const displayName = formDisplayNames[activeSlug];
        const formLink = document.getElementById('cart-form-name');

        if (formLink && displayName && formUrl) {
            formLink.textContent = displayName;
            formLink.setAttribute('href', formUrl);
        }
    };
    function setCartFormNameFromSlug(slug) {
        const formLink = document.getElementById('cart-form-name');
        const displayName = formDisplayNames[slug];

        if (formLink && displayName) {
            formLink.textContent = displayName;
            formLink.setAttribute('href', slug);
        }
    }

    // Close cart drawer when clicking page
    const closeCartDrawer = () => {
        const overlay = document.getElementById('cart-overlay');
        const drawer = document.getElementById('cart-drawer');
        drawer?.classList.remove('show');
        overlay?.classList.remove('show');

        setTimeout(() => {
            drawer?.classList.add('hidden');
            overlay?.classList.add('hidden');
        }, 300);
    };

    // Other methods to close cart
    document.querySelector('.close-cart')?.addEventListener('click', closeCartDrawer);
    document.querySelector('.continue-btn')?.addEventListener('click', closeCartDrawer);
    document.getElementById('cart-overlay')?.addEventListener('click', (e) => {
        const drawer = document.getElementById('cart-drawer');
        if (!drawer.contains(e.target)) {
            closeCartDrawer();
        }
    });

    // Direct user to associated form
    document.querySelector('.checkout-btn')?.addEventListener('click', () => {
        const savedUrl = localStorage.getItem(PREFIX + SAVED_FORM_KEY);

        if (savedUrl) {
            window.location.href = savedUrl;
        } else {
            console.warn("No saved form URL found. Redirect canceled.");
        }
    });

    // Handle where CTA banner is present on top of page
    if (document.querySelector('.cta-banner-wrapper')) {
        const main = document.querySelector('main');
        if (main) {
            main.classList.add('has-cta-banner');
        }
    }

    saveFormURL()
    renderCartTabs()
    setupCartTabEvents()
    initializeCartTabs()
    setCartFormName()
    maybeShowShoppingCart()
}


